<template lang="pug">
  .inline-socials
    a.inline-socials__link(
      v-if="vk"
      target="_blank"
      :class="classLink"
      :href="vk"
    )
      Icon.inline-socials__icon( :class="classIcon" :icon="'vk-'+ ( uncolor ? 'icon' :'color')")

    a.inline-socials__link(
      v-if="fb"
      target="_blank"
      :class="classLink"
      :href="fb"
    )
      Icon.inline-socials__icon( :class="classIcon" :icon="'fb-'+  ( uncolor ? 'icon' :'color')")

    a.inline-socials__link(
      v-if="insta"
      target="_blank"
      :class="classLink"
      :href="insta"
    )
      Icon.inline-socials__icon( :class="classIcon" :icon="'insta-'+  ( uncolor ? 'icon' :'color')")

</template>

<script>
export default {
  props: ['vk', 'fb', 'insta', 'uncolor', 'classIcon', 'classLink']
};
</script>
